module.exports = __webpack_public_path__ + "img/explicit-traits.94271bd5.png";